import { PlotSection } from '@/warranty-v3/components/plot-section';
import { Card, CardContent } from '@/warranty-v3/components/ui/card';
import type { ConditionViolation } from '@/warranty-v3/entities/condition-violation';

import { ConditionViolationsChart } from './condition-violations-chart';
import { ConditionViolationsIntroBox } from './condition-violations-intro-box';
import { ConditionViolationsTable } from './condition-violations-table';

export type ConditionViolationsProps = {
  conditionViolations: ConditionViolation[];
};

export function ConditionViolations({
  conditionViolations,
}: ConditionViolationsProps) {
  return (
    <PlotSection sectionName="Condition Violations">
      <Card className="w-full overflow-x-auto">
        <CardContent>
          <ConditionViolationsIntroBox />

          <div className="flex flex-row gap-x-10">
            <div className="h-96 w-2/5 shrink-0">
              <ConditionViolationsChart
                conditionViolations={conditionViolations}
              />
            </div>

            <div className="h-96 w-2/5 grow">
              <ConditionViolationsTable
                conditionViolations={conditionViolations}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </PlotSection>
  );
}
